// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ii9m","comment":"styles_comment__bAP5d"};